import { Forecasts } from 'pleinchamp-api-client';
import { FC } from 'react';
import { MeteoWeatherTableContent } from '@meteo/components/MeteoWeatherTable/MeteoWeatherTableContent/MeteoWeatherTableContent';
import { WeatherCode } from '@meteo/types';
import { plcDayjs } from '@utils/date';

export interface MeteoWeatherTableMockProps {
  isLoading?: boolean;
}

const MeteoWeatherTableMock: FC<MeteoWeatherTableMockProps> = ({ isLoading }) => {
  const mockLength = 12;
  const dates = Array.from({ length: mockLength }, (_, k) => plcDayjs().add(k * 3, 'hour'));
  const weatherCodes = Array.from({ length: mockLength }, () => WeatherCode.ClearSkies);
  const metrics: Forecasts = {} as Forecasts;

  return (
    <MeteoWeatherTableContent
      coordinates={{ latitude: 1, longitude: 1 }}
      dates={dates}
      format15Days
      isChartEnabled={false}
      isLoading={isLoading}
      metrics={metrics}
      timeframe="PT0S"
      weatherCodes={weatherCodes}
    />
  );
};

export { MeteoWeatherTableMock };
